import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { ReplaySubject, Subscription, takeUntil } from 'rxjs';
import { MasterUrlService } from '../../services/SmasterUrl.service';
import { OPD_API_URL } from '../../properties/opd-url-properties';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MASTERSSERVICES } from 'projects/lib/medcare-core-lib/src/lib/constants/master-service';
import { MultiLanguageService } from 'projects/lib/medcare-core-lib/src/lib/core/multi-language/multi-language.service';
import { AuthService } from 'projects/lib/medcare-core-lib/src/lib/services/auth.service';
import { AppBaseService } from 'projects/lib/medcare-core-lib/src/lib/services/http.service';
import { baseObj } from '../../interface/IerRegistration';

@Component({
  selector: 'app-change-provider',
  templateUrl: './change-provider.component.html',
  styleUrls: ['./change-provider.component.scss']
})
export class ChangeProviderComponent implements OnInit,OnDestroy {
  private unsubscribe: ReplaySubject<boolean> = new ReplaySubject(1);
  private subscriptionList = new Subscription();
  encounterTypeList: baseObj[]=[];
  specialityList: baseObj[]=[];
  unitCode: string;
  
  doctorList: baseObj[]=[];
  clinicList: baseObj[]=[];
  reasonList: any[]=[];
  isDepartmentVisit: boolean = false;
  EncounterId: string;
  isVisitToDepartment: boolean =false;
  changeProvide: FormGroup;
  encounterTypeFilterList: baseObj[]=[];
  specialityFilterList: baseObj[]=[];
  doctorFilterList: baseObj[]=[];
  clinicFilterList: baseObj[]=[];
  reasonfilterList: baseObj[]=[];
  
  encounterTypeSearchCtrl: FormControl = new FormControl();
  specialitySearchCtrl: FormControl = new FormControl();
  doctorSearchCtrl: FormControl = new FormControl();
  clinicSearchCtrl: FormControl = new FormControl();
  reasonSearchCtrl: FormControl = new FormControl();

  constructor(
    public dialogRef: MatDialogRef<ChangeProviderComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public masterApiService: MasterUrlService,
    private authService:AuthService,
    private appBaseService: AppBaseService,
    public snackBar: MatSnackBar,
    private langService: MultiLanguageService,
    private formBuilder: FormBuilder,
  ) { }

  ngOnInit(): void {
    this.changeProvide = this.formBuilder.group({
      clinic: [''],
      reason:[''],
      doctor:[''],
      speciality:[''],
      encounterType:[''],
      remark:"",
  });
    this.getUnitData();
    this.getAllMaster();
    this.onChanges();
  }

  ngOnDestroy() { 
    this.unsubscribe.next(true);
    this.unsubscribe.complete();
    this.subscriptionList.unsubscribe();
  }
  getUnitData() {
    this.authService.getUnit().then((value: any) => {
      this.unitCode = value.unitCode;
    });
  }
  onChanges(){
    this.subscriptionList.add(
      this.encounterTypeSearchCtrl.valueChanges.subscribe((value) => {
        this.encounterTypeFilterList = this.encounterTypeList.filter((i) =>
          i.desc.toString().toLowerCase().includes(value.toLowerCase())
        );
      })
    );
    this.subscriptionList.add(
      this.specialitySearchCtrl.valueChanges.subscribe((value) => {
        this.specialityFilterList = this.specialityList.filter((i) =>
          i.desc.toString().toLowerCase().includes(value.toLowerCase())
        );
      })
    );
    this.subscriptionList.add(
      this.doctorSearchCtrl.valueChanges.subscribe((value) => {
        this.doctorFilterList = this.doctorList.filter((i) =>
          i.desc.toString().toLowerCase().includes(value.toLowerCase())
        );
      })
    );
    this.subscriptionList.add(
      this.clinicSearchCtrl.valueChanges.subscribe((value) => {
        this.clinicFilterList = this.clinicList.filter((i) =>
          i.desc.toString().toLowerCase().includes(value.toLowerCase())
        );
      })
    );
    this.subscriptionList.add(
      this.reasonSearchCtrl.valueChanges.subscribe((value) => {
        this.reasonfilterList = this.reasonList.filter((i) =>
          i.desc.toString().toLowerCase().includes(value.toLowerCase())
        );
      })
    );
  }
  getAllMaster(){
    this.getEncounterList();
    this.getSpecialityList();
    this.getClinicList();
    this.getReasonList();
  }
  getEncounterList() {
    this.masterApiService
      .getTypeMaster(MASTERSSERVICES.ENCOUNTER_TYPE_MASTER,true)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((data: any) => {
        this.encounterTypeList = data;
        this.encounterTypeFilterList=this.encounterTypeList;
      });
  }
  getSpecialityList() {
    this.masterApiService
      .getTypeMaster(MASTERSSERVICES.DEPT_GET_DEPT_BY_UNIT)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((data: any) => {
        this.specialityList = data;
        this.specialityFilterList=this.specialityList;
      });
  }
  getDoctorList(departmentCode) {
    this.doctorList=[];
      let payload = {
        limit: 0,
        unitCode: this.unitCode,
        departmentCode:  departmentCode.value.code,
        typeCodeList: ["DR"],
      };
      this.masterApiService
        .postTypeMaster(OPD_API_URL.EMPLOYEE_LIST, payload)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe((data: any) => {
          if (data && data.payload &&
            data.payload.employeeResponseList &&
            data.payload.employeeResponseList.length > 0
          ) {
            this.doctorList= data.payload.employeeResponseList;
            this.doctorFilterList=this.doctorList;
          }
        });
  }
  getClinicList() {
    this.masterApiService
      .getTypeMaster(MASTERSSERVICES.CABIN_MASTER)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((data: any) => {
        this.clinicList = data;
        this.clinicFilterList=this.clinicList;
      });
  }
  getReasonList(){
    this.masterApiService
      .getTypeMaster(OPD_API_URL.M_REASON_MASTER_QUERY_NEW+ "ENDC",true)
      .pipe(takeUntil(this.unsubscribe))
        .subscribe((res) => {
         this.reasonList=res;
         this.reasonfilterList=this.reasonList;
        });
  }
  onClose(){
    this.dialogRef.close();
  }

  Submit(){
    if(this.changeProvide.valid){
    let payload={
      encounterId: this.data ? this.data.id:"",
      encounterTypeList: this.changeProvide.controls['encounterType'].value
          ? this.langService.createObjectList(this.changeProvide.controls['encounterType'].value)
          : [],
      departmentList:this.changeProvide.controls['speciality'].value
      ? this.langService.createObjectList(this.changeProvide.controls['speciality'].value)
      :[],
      doctorList: this.changeProvide.controls['doctor'].value
      ? this.langService.createObjectList(this.changeProvide.controls['doctor'].value)
      : [],
      clinicList: this.changeProvide.controls['clinic'].value
      ? this.langService.createObjectList(this.changeProvide.controls['clinic'].value)
      : [],
      reasonList:this.changeProvide.controls['reason'].value
      ? this.langService.createObjectList(this.changeProvide.controls['reason'].value)
      : [],
      remark:this.changeProvide.controls['remark'].value ? this.changeProvide.controls['remark'].value : "",
      isVisitToDepartment:  this.isVisitToDepartment,
    }
    this.appBaseService.setResourceURL(OPD_API_URL.OPD_SERVICE);
      this.appBaseService
        .putResource(
          OPD_API_URL.OPD_CHANGE_PROVIDER ,payload) 
          .pipe(takeUntil(this.unsubscribe))
        .subscribe((res) => {
          if(res){
            this.snackBar.open(
              "Message",res.message,{duration: 1000,}
            );
            this.dialogRef.close();
          }
        }
      )
    }else{
      this.changeProvide.markAllAsTouched();
      this.snackBar.open(
        this.langService.get("CommonAppoinment.pleasefillallmandatory"),
        this.langService.get("CommonAppoinment.validation"),
        {
          duration: 3000,
        }
      );
    }
  }
  toggleDepartmentVisit(event: any) {
    if(event.checked){
    this.isDepartmentVisit = true;
    this.isVisitToDepartment = true;
    }else{
      this.isVisitToDepartment = false;
      this.isDepartmentVisit = false;
    }
  }
}  

